import SpecFunction from '../../specs/SpecFunction';
import ConsistencyChecksManager from './ConsistencyChecksManager';

type CoherenceInput = {
    "label": string
    "function": string,
    "textError": string,
    "level": number
}
export default class ConsistencyCheck extends SpecFunction {

    subConsistencyChecks: ConsistencyChecksManager = null

    constructor (
        key: string,
        func: string,
        specManager: ConsistencyChecksManager,
        public label: string,
        public level: number,
        private _textError: string,
        listControl: { [k: string]: CoherenceInput } = null
    ){
        super(key, func, specManager)
        if (listControl) {
            this.subConsistencyChecks = new ConsistencyChecksManager(specManager.bundleBase, listControl, specManager.radicals)
        }
    }

    get textError() {
        if (this.subConsistencyChecks) {
            //
        }
        // if (this.isValid) {
        return this._textError
        // }
        // return ""
    }

    get isValid() {
        if (this.subConsistencyChecks) {
            return this.subConsistencyChecks.allChecksValid
        }
        this.build()
        return !this.value
    }

    get cerfa() {
        return this.label.split(" ")[0]
    }

    get icon() {
        if (this.isValid) {
            return '$oss-circle-check'
        } else {
            if (this.level === 1) {
                return '$oss-warning'
            } else {
                return '$oss-bell'
            }
        }
    }

    get iconColor() {
        if (this.isValid) {
            return 'yellow_custom'
        } else {
            if (this.level === 1) {
                return 'red'
            } else {
                return 'yellow_custom'
            }
        }
    }
}
